<template>
  <CaseStudy
    title="TRUMP"
    :logo="require('@/assets/logos/trump.png')"
    :thumbnail="require('@/assets/screenshots/trump.png')"
    iframeLink="https://iframe.bubblemaps.io/map/Lr6FqWpO55uoDVja3gbz?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1891828882367553986"
    :featuredIn="[
      {
        name: 'Reuters',
        logo: require('@/assets/logos/medias/reuters.png'),
        link: 'https://www.reuters.com/sustainability/boards-policy-regulation/crypto-exchanges-rushed-list-trumps-coin-leaving-many-losers-some-big-winners-2025-07-14',
      },
      {
        name: 'Financial Times',
        logo: require('@/assets/logos/medias/financialtimes.png'),
        link: 'https://www.ft.com/content/cb1def8f-53a6-478e-9b3e-33c383b29629',
        color: '#FDF2E6',
      },
      {
        name: 'The New York Times',
        logo: require('@/assets/logos/medias/newyorktimes.png'),
        link: 'https://www.nytimes.com/2025/05/12/us/politics/trump-crypto-coin-auction.html',
        color: '#000000',
      },
    ]"
  >
    How a sniper made <b>over $100M</b> on Trump’s meme coin while early buyers
    got dumped on
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
